// import something here

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default ({ Vue }) => {
  const vars = {
    months: [
      {label: 'Enero', value: '01'},
      {label: 'Febrero', value: '02'},
      {label: 'Marzo', value: '03'},
      {label: 'Abril', value: '04'},
      {label: 'Mayo', value: '05'},
      {label: 'Junio', value: '06'},
      {label: 'Julio', value: '07'},
      {label: 'Agosto', value: '08'},
      {label: 'Septiembre', value: '09'},
      {label: 'Octubre', value: '10'},
      {label: 'Noviembre', value: '11'},
      {label: 'Diciembre', value: '12'},
    ]
  }

  Vue.prototype.$static = vars
}
